export const API_URL = "http://127.0.0.1:8080/forth-real/us-central1"

// Feature flags configuration
export const FEATURE_FLAGS = {
  // Email verification signup is now the default signup experience
  // Set to false via environment variable to use the legacy signup flow
  USE_EMAIL_VERIFICATION_SIGNUP: process.env.REACT_APP_USE_EMAIL_VERIFICATION_SIGNUP !== 'false',
  
  // Additional feature flags can be added here
  ENABLE_ANALYTICS_TRACKING: true,
  ENABLE_BETA_FEATURES: false,
}

// Helper function to check feature flags
export const isFeatureEnabled = (flagName: keyof typeof FEATURE_FLAGS): boolean => {
  return FEATURE_FLAGS[flagName] === true
}

export default ""